export default ({ dropdown }) => {
  const { checkbox } = dropdown;
  return {
    root: {
      background: dropdown.background,
      border: 0,
      color: dropdown.text,
      cursor: 'pointer',
      fontSize: dropdown.fontSize,
      padding: [0, 20, 0, 12],
      position: 'relative',
      textAlign: 'left',
      width: '100%',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      display: 'block',
      textOverflow: 'ellipsis',
      fontFamily: dropdown.fontFamily,
      height: 32,
      lineHeight: '32px',
      '& p': {
        fontSize: dropdown.fontSize,
        marginRight: 3,
        margin: 0,
        cursor: 'pointer',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      },
      '& label': {
        margin: 0,
        height: 32,
        display: 'inline-flex',
        width: '100%',
        alignItems: 'center'
      },
      '&:hover, &:focus': {
        background: dropdown.hoverBg
      },
      '&:focus': {
        outlineColor: dropdown.focusColor
      }
    },
    singleOptionWrapper: {
      position: 'relative'
    },
    depth1: { paddingLeft: 16 },
    depth2: { paddingLeft: 32 },
    depth3: { paddingLeft: 48 },
    depth4: { paddingLeft: 64 },
    depth5: { paddingLeft: 80 },
    depth6: { paddingLeft: 96 },
    disabled: {
      opacity: 0.5
    },
    highlight: {
      background: dropdown.highlightBg
    },
    selected: {
      background: dropdown.hoverBg
    },
    categoryButton: {
      border: 0,
      background: 'transparent',
      width: 38,
      height: 32,
      position: 'absolute',
      top: 0,
      right: 0,
      '&:hover': {
        cursor: 'pointer'
      },
      '&:disabled': {
        cursor: 'not-allowed',
        color: dropdown.disabledText
      },
      '&:focus': {
        outlineColor: dropdown.focusColor
      }
    },
    icon: {
      '& svg': {
        height: 12,
        fill: dropdown.iconFill
      },
      '&$dark svg': {
        fill: dropdown.dark.iconFill
      },
      position: 'absolute',
      right: 13,
      top: 11
    },
    checkboxRoot: {
      position: 'relative',
      cursor: 'pointer',
      height: 18,
      lineHeight: '18px',
      padding: [0, 0, 0, 26],
      marginBottom: 15,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      display: 'inline-block!important',
      textOverflow: 'ellipsis',
      '& input': {
        width: 16,
        height: 16,
        margin: 0,
        zIndex: 1,
        left: 0,
        position: 'absolute',
        top: '50%',
        marginTop: -9,
        opacity: 0
      },
      '& p': {
        margin: 0
      },
      '& input:focus + $checkboxIcon': {
        outline: `${checkbox.selectedColor} solid 1px`,
        boxShadow: `0 0px 8px ${checkbox.shadowColor}`
      }
    },
    checkboxLabelText: {
      position: 'relative',
      top: 7,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      display: 'inline-block',
      textOverflow: 'ellipsis',
      width: '98%'
    },
    checkboxDisabled: {
      opacity: 0.5
    },
    checkboxSelected: {},
    checkboxIcon: {
      background: 'transparent',
      borderColor: checkbox.borderColor,
      borderRadius: 2,
      borderStyle: 'solid',
      borderWidth: 1,
      display: 'inline-block',
      height: 16,
      left: 0,
      marginTop: -9,
      position: 'absolute',
      top: '50%',
      width: 16,
      '& svg': {
        fill: checkbox.checkColor,
        width: 8,
        height: 8,
        position: 'absolute',
        left: 3,
        top: 3
      },
      '&$checkboxSelected': {
        background: checkbox.selectedColor,
        borderColor: checkbox.selectedColor
      }
    },
    dark: {
      '&$root': {
        background: dropdown.dark.background,
        color: dropdown.dark.text,
        '&:hover, &:focus': {
          background: dropdown.dark.hoverBg
        },
        '&:focus': {
          outlineColor: dropdown.dark.darkFocusColor
        }
      },
      '&$highlight': {
        background: dropdown.dark.highlightBg
      },
      '&$selected': {
        background: dropdown.dark.hoverBg
      },
      '& $categoryButton': {
        '&:disabled': {
          color: dropdown.dark.disabledText
        },
        '&:focus': {
          outlineColor: dropdown.dark.darkFocusColor
        }
      },
      '& $checkboxIcon': {
        borderColor: checkbox.dark.borderColor
      },
      '& $checkboxSelected': {
        background: checkbox.dark.selectedColor,
        borderColor: checkbox.dark.selectedColor
      },
      '& svg': {
        fill: checkbox.dark.checkColor
      }
    }
  };
};
